import axios from 'axios'
import { useState } from 'react'

// const [octopusConnectionStatus, setOctopusConnectionStatus] = useState({})
let octopusConnectionStatus = {}
const setOctopusConnectionStatus = status => {
    octopusConnectionStatus = status
}
// const [octopusSetRWLMock, setOctopusSetRWLMock] = useState(false)
let octopusSetRWLMock = false
const setOctopusSetRWLMock = status => {
    octopusSetRWLMock = status
}

const config = {
    server: null,
    timeout: 5000,
    init_timeout: 30000,
    retry_interval: 60000,
}

const server = config.server || 'http://localhost:4000'
const timeout = config.timeout || 5000
const initTimeout = config.init_timeout || 30000 // 30 seconds by default
const retryInterval = config.retry_interval || 60000

let reconnectProcess = null

const httpClient = axios.create({
    baseURL: `${server}/api`,
    timeout,
})
httpClient.interceptors.response.use(response => {
    console.log('octopus response', response.data);
    if (typeof response.data === 'string') {
        response.data = JSON.parse(response.data, true)
    }
    const statusCode = parseInt(response.data.data.code)
    // 100001 R/W not connected
    // 100005 Invalid response from R/W
    // 100099 firmware upgrade has performed
    const status = statusCode !== 100001 && statusCode !== 100005 && statusCode !== 100099
    // store.dispatch('octopus/setConnectionStatus', { available: status, lastStatusCode: statusCode < 100000 ? 0 : statusCode })
    setOctopusConnectionStatus({ available: status, lastStatusCode: statusCode < 100000 ? 0 : statusCode })
    setConnectionStatus(status)
    return response
}, error => {
    setConnectionStatus(false)
    // store.dispatch('octopus/setConnectionStatus', { available: false, lastStatusCode: 'encountered error' })
    setOctopusConnectionStatus({ available: false, lastStatusCode: 'encountered error' })
    return Promise.reject(error)
})

const setConnectionStatus = status => {
    if (!status) {
        // reconnect only if require connection
        // if (!reconnectProcess && store.getters['octopus/requireConnection']) {
        //     reconnectProcess = setInterval(() => {
        //         rwl.initComm()
        //             .then(() => {
        //                 // clear interval if success
        //                 if (reconnectProcess) {
        //                     clearInterval(reconnectProcess)
        //                     reconnectProcess = null
        //                 }
        //             })
        //             .catch(error => {
        //                 Vue.log.error(`Error while reconnecting RWL service: ${error.message}`)
        //             })
        //     }, retryInterval)
        // }
    }

    // store.commit('octopus/SET_CONNECTION_STATUS', status)
}

const setDevice = device => {
    // store.commit('octopus/SET_DEVICE', device)
}

const rwl = {
    initComm: () => {
        return new Promise((resolve, reject) => {
            httpClient.get('/octopus/initComm', { timeout: initTimeout })
                .then(({ data }) => {
                    const result = data.data
                    // if there is a mock, set rwlMock in store state to true,
                    try {
                        if (result.data.mock === 1) {
                            // Vue.log.info('detecting rwl server in mock mode')
                            console.log('detecting rwl server in mock mode');
                            // store.commit('octopus/SET_RWLMOCK', true)
                            setOctopusSetRWLMock(true)
                        } else {
                            // Vue.log.info('detecting rwl server in production mode')
                            console.log('detecting rwl server in production mode');
                            // store.commit('octopus/SET_RWLMOCK', false)
                            setOctopusSetRWLMock(false)
                        }
                    } catch (e) {
                        // Vue.log.error('error in detecting rwl mode default to production mode')
                        console.log('error in detecting rwl mode default to production mode');
                        // store.commit('octopus/SET_RWLMOCK', false)
                        setOctopusSetRWLMock(false)
                    }
                    if (result.status === 'success') {
                        const status = result.statusCode !== 100001 && result.statusCode !== 100005 && result.statusCode !== 100099
                        // store.dispatch('octopus/setConnectionStatus', { available: status, lastStatusCode: result.statusCode || 0 })
                        setOctopusConnectionStatus({ available: status, lastStatusCode: result.statusCode || 0 })
                        return resolve(0)
                    }

                    reject({
                        message: data.message,
                        error: result.code,
                    })
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    timeVer: () => {
        return new Promise((resolve, reject) => {
            httpClient.get('/octopus/timeVer')
                .then(({ data }) => {
                    const result = data.data

                    if (result.status === 'success') {
                        const device = result.data
                        setDevice(device)
                        return resolve(device)
                    }

                    reject({
                        message: data.message,
                        error: result.code,
                    })
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    poll: () => {
        return new Promise((resolve, reject) => {
            httpClient.get('/octopus/poll')
                .then(({ data }) => {
                    const result = data.data
                    setTimeout(() => {
                        if (result.status === 'error') {
                            reject({
                                type: 'poll',
                                message: data.message,
                                error: result.code,
                            })
                        }

                        resolve({
                            pollStatus: result.code,
                            pollData: result.data,
                        })
                    }, 250)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    deduct: ({ amount, transactionId, cardNumber }) => {
        console.log('deduct amount', amount);
        console.log('deduct transactionId', transactionId);
        console.log('deduct cardNumber', cardNumber);

        return new Promise((resolve, reject) => {
            httpClient.post('/octopus/deduct', {
                amount,
                transactionId,
                cardNumber,
            }).then(({ data }) => {
                // make data string to json
                // const result = JSON.parse(data.data)
                const result = data.data
                console.log('deduct data', data);

                let deductStatus = result.data ? result.data.value : result.code

                if (result.status === 'error') {
                    reject({
                        type: 'deduct',
                        message: 'Failed to deduct octopus card amount',
                        error: deductStatus,
                    })
                }

                resolve(deductStatus)
            }).catch(error => {
                reject(error)
            })
        })
    },

    getExtraInfo: () => {
        return new Promise((resolve, reject) => {
            httpClient.get('/octopus/getExtraInfo')
                .then(({ data }) => {
                    const result = data.data
                    let extraInfoData = result.data

                    if (result.status === 'error') {
                        reject({
                            type: 'getExtraInfo',
                            message: 'Failed to get card extra information',
                            error: result.code,
                        })
                    }

                    resolve(extraInfoData)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    portClose: () => {
        return new Promise((resolve, reject) => {
            httpClient.get('/octopus/portClose')
                .then(({ data }) => {
                    const result = data.data
                    if (result.status === 'success') {
                        return resolve(0)
                    }

                    reject({
                        message: data.message,
                        error: result.code,
                    })
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    dailyJob: () => {
        return new Promise((resolve, reject) => {
            httpClient.get('/octopus/dailyJob')
                .then(({ data }) => {
                    const result = data.data

                    if (result.status === 'success') {
                        resolve(true)
                    } else {
                        reject({
                            message: data.message,
                        })
                    }
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}

export default rwl
